import { createSlice, PayloadAction } from '@reduxjs/toolkit';

type TrajectoryPrintPdfSlice = {
  showTrajectoryPrintPdfSlice: boolean;
};

const initialState: TrajectoryPrintPdfSlice = {
  showTrajectoryPrintPdfSlice: false,
};

export const trajectoryPrintPdfSlice = createSlice({
  name: 'trajectoryPrintPdfSlice',
  initialState,
  reducers: {
    setShowTrajectoryPrintPdfSlice: (state, action: PayloadAction<boolean>) => {
      return { ...state, showTrajectoryPrintPdfSlice: action.payload };
    },
  },
});

export const { setShowTrajectoryPrintPdfSlice } = trajectoryPrintPdfSlice.actions;

export const { reducer: trajectoryPrintPdfSliceReducer } = trajectoryPrintPdfSlice;
